export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6780.4f98b41f.jpg";